/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_LapsInputs */

const en_ui_laps = /** @type {(inputs: Ui_LapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laps`)
};

const de_ui_laps = /** @type {(inputs: Ui_LapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runden`)
};

/**
* | output |
* | --- |
* | "Laps" |
*
* @param {Ui_LapsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps = /** @type {((inputs?: Ui_LapsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_LapsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps(inputs)
	return de_ui_laps(inputs)
});